export var TrainingSessionItemEval;
(function (TrainingSessionItemEval) {
    TrainingSessionItemEval["GOOD"] = "GOOD";
    TrainingSessionItemEval["BAD"] = "BAD";
})(TrainingSessionItemEval || (TrainingSessionItemEval = {}));
//# sourceMappingURL=training-session-item-eval.enum.js.map